import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Clock } from "lucide-react";

export default function Tests() {
  const [list, setList] = useState<any[]>([]);
  useEffect(() => {
    supabase.from("tests").select("*").eq("published", true).order("sort_order").then(({ data }) => setList(data || []));
  }, []);
  return (
    <div className="space-y-6 max-w-5xl mx-auto">
      <div>
        <h1 className="text-3xl font-bold">Tests</h1>
        <p className="text-muted-foreground">Practice and track your JLPT readiness.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {list.map((t) => (
          <Link key={t.id} to={`/tests/${t.slug}`}>
            <Card className="hover:shadow-md transition-shadow h-full">
              <CardHeader>
                <div className="flex items-center justify-between">
                  <CardTitle className="text-base">{t.title}</CardTitle>
                  <Badge>{t.jlpt_level}</Badge>
                </div>
              </CardHeader>
              <CardContent className="space-y-2">
                <p className="text-sm text-muted-foreground line-clamp-2">{t.description}</p>
                {t.time_limit_minutes && (
                  <div className="text-xs text-muted-foreground flex items-center gap-1">
                    <Clock className="h-3 w-3" /> {t.time_limit_minutes} min
                  </div>
                )}
              </CardContent>
            </Card>
          </Link>
        ))}
        {!list.length && <p className="text-muted-foreground">No tests yet.</p>}
      </div>
    </div>
  );
}
